import { render, staticRenderFns } from "./add-authorize.vue?vue&type=template&id=62b9c150&scoped=true&"
import script from "./add-authorize.vue?vue&type=script&lang=js&"
export * from "./add-authorize.vue?vue&type=script&lang=js&"
import style0 from "./add-authorize.vue?vue&type=style&index=0&id=62b9c150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9c150",
  null
  
)

export default component.exports